/* Social-Kommentar-Karussell: Dots synchron zum Scroll-Snap-Track.
   Initialisiert jeden [data-fbc] Container auf der Seite, auch mehrfach
   vorhandene, und ist gegen doppeltes Einbinden abgesichert. */
(function () {
  if (window.__smeluFbcInit) return;
  window.__smeluFbcInit = true;

  function init(root) {
    if (root.dataset.fbcReady === '1') return;
    root.dataset.fbcReady = '1';

    var track = root.querySelector('[data-fbc-track]');
    var dots = root.querySelectorAll('[data-fbc-dot]');
    if (!track || !dots.length) return;

    var cards = track.querySelectorAll('.smelu-fbc');
    if (cards.length < 2) return;

    function step() {
      return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
    }
    function current() {
      var s = step();
      return s ? Math.round(track.scrollLeft / s) : 0;
    }
    function sync() {
      var i = Math.max(0, Math.min(cards.length - 1, current()));
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === i);
      }
    }
    for (var k = 0; k < dots.length; k++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () {
          track.scrollTo({ left: idx * step(), behavior: 'smooth' });
        });
      })(k);
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-fbc]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Theme-Editor: Sections werden neu gerendert, dann erneut initialisieren.
  document.addEventListener('shopify:section:load', boot);
})();
